module.exports = __webpack_public_path__ + "095681d10316f02c8b6efa3c605f2adf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/cell-phone.png
// module id = 2503
// module chunks = 0